// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-container {
  display: flex;
  height: 70vh;
}

.group-header {
  margin-bottom: 20px;
  padding: 30px 30px;
  border: 1px solid #ddd;
  border-radius: 5px;
  max-width: 30vw;
  /* background-color: #f9f9f9; */
}
.group-table-container {
  width: 70vw;
  padding-left: 30px;
}
.group_head {
  color: black;
  font-size: 18px;
  margin: 20px 0 10px 0;
}
.group_membaer_heading {
  margin-bottom: 15px;
  /* left: 500px; */
  position: relative;
}

.group_content {
  color: #1a661a; /* Dark color for dynamic content */
  font-weight: bold; /* Make dynamic content bold */
  font-size: 22px;
}
.group_descrip {
  padding-left: 7px;
}
.details_row {
  grid-template-columns: 1fr 2fr 2fr;
}

.group-table-container {
  display: flex;
  flex-direction: column;
}

.header-with-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aligns the dropdown with the heading */
  margin-bottom: 1rem; /* Space between header and table */
}

.dropdown_create {
  position: relative;
}

.dropdown-options_create {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: white; /* Adjust background color as needed */
  border: 1px solid #ccc; /* Adjust border as needed */
  width: max-content; /* Ensure dropdown is not too wide */
}

.create_button {
  background-color: rgb(132, 199, 174);
  cursor: pointer;
  padding: 5px 8px;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #75c58a;
  gap: 12px;
}

/*  */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Darken background */
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  z-index: 999; /* Make sure it's on top of other elements */
}

.popup {
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 2.5em;
  cursor: pointer;
}

.group_add_member {
  position: relative;
  text-align: center;
  font-size: 18px;
  padding-top: 15px;
  font-weight: 600;
  padding-left: 15vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GroupsSection/DisplayGroupDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,mCAAmC;EACnD,iBAAiB,EAAE,8BAA8B;EACjD,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAE,yCAAyC;EAC9D,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB,EAAE,sCAAsC;EACzD,sBAAsB,EAAE,4BAA4B;EACpD,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA,KAAK;AACL;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,sBAAsB;EAC5D,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,YAAY,EAAE,4CAA4C;AAC5D;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".group-container {\n  display: flex;\n  height: 70vh;\n}\n\n.group-header {\n  margin-bottom: 20px;\n  padding: 30px 30px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  max-width: 30vw;\n  /* background-color: #f9f9f9; */\n}\n.group-table-container {\n  width: 70vw;\n  padding-left: 30px;\n}\n.group_head {\n  color: black;\n  font-size: 18px;\n  margin: 20px 0 10px 0;\n}\n.group_membaer_heading {\n  margin-bottom: 15px;\n  /* left: 500px; */\n  position: relative;\n}\n\n.group_content {\n  color: #1a661a; /* Dark color for dynamic content */\n  font-weight: bold; /* Make dynamic content bold */\n  font-size: 22px;\n}\n.group_descrip {\n  padding-left: 7px;\n}\n.details_row {\n  grid-template-columns: 1fr 2fr 2fr;\n}\n\n.group-table-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.header-with-dropdown {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; /* Aligns the dropdown with the heading */\n  margin-bottom: 1rem; /* Space between header and table */\n}\n\n.dropdown_create {\n  position: relative;\n}\n\n.dropdown-options_create {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 10;\n  background: white; /* Adjust background color as needed */\n  border: 1px solid #ccc; /* Adjust border as needed */\n  width: max-content; /* Ensure dropdown is not too wide */\n}\n\n.create_button {\n  background-color: rgb(132, 199, 174);\n  cursor: pointer;\n  padding: 5px 8px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: #75c58a;\n  gap: 12px;\n}\n\n/*  */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7); /* Darken background */\n  display: flex;\n  align-items: center; /* Center vertically */\n  justify-content: center; /* Center horizontally */\n  z-index: 999; /* Make sure it's on top of other elements */\n}\n\n.popup {\n  background-color: white;\n  padding: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n  position: relative;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 2.5em;\n  cursor: pointer;\n}\n\n.group_add_member {\n  position: relative;\n  text-align: center;\n  font-size: 18px;\n  padding-top: 15px;\n  font-weight: 600;\n  padding-left: 15vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
